// extracted by mini-css-extract-plugin
export var hasBorderRadiusStyle = "video-module--hasBorderRadiusStyle--4CrgZ";
export var hasShadowStyle = "video-module--hasShadowStyle--froYh";
export var videoStyle = "video-module--videoStyle--bYeEO";
export var wrapperStyle = "video-module--wrapperStyle--mKfi8";